"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorReplacementPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const ReplacementContainer_style_1 = require("./ReplacementContainer.style");
function ColorReplacementPanel({ colors: colorProps, onClick, title, }) {
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const items = (0, react_1.useMemo)(() => {
        return colorProps.map((color, index) => {
            const colors = color.palette.map((color) => ({
                label: color,
                color,
                variant: 'circle',
            }));
            return ((0, jsx_runtime_1.jsx)(ui_common_components_1.ColorGrid, { titleKey: title, colors: colors, bulletStyle: 'circle', onClick: (colorClick) => onClick({
                    action: 'color_replace',
                    source: colorClick,
                    details: color,
                }) }, `color-grid-${index}`));
        });
    }, [colorProps, onClick, t]);
    return (0, jsx_runtime_1.jsx)(ReplacementContainer_style_1.StyledWorkspaceWrapper, { children: items });
}
exports.ColorReplacementPanel = ColorReplacementPanel;
//# sourceMappingURL=ColorReplacementPanel.js.map